import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { CONSENT_OPTIONS } from "@/constants/statuses";

// Shared by ResultsTable (table cell) and MessageDialog (inline warning) —
// kept in its own file so the two don't need to import from each other.
export const ConsentSelect = ({ b, onConsentChange, className = "" }) => (
  <Select value={b.consent || "none"} onValueChange={(v) => onConsentChange(b.place_id, v)}>
    <SelectTrigger
      data-testid={`consent-select-${b.place_id}`}
      className={`h-8 text-xs ${b.consent && b.consent !== "none" ? "" : "text-muted-foreground"} ${className}`}
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {CONSENT_OPTIONS.map((c) => (
        <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
